import 'assets/scripts/maps';

export default () => {
	$( '.maps' ).maps( {
		map: {
			disableDefaultUI: true,
			zoomControl: true,
		},
		infobox: {
			closeBoxMargin: '-15px -15px 0px 0px',
			pixelOffset: new google.maps.Size( 0, 110 ),
			closeBoxURL: 'https://www.google.com/intl/en_us/mapfiles/close.gif',
		},
	} );
};
